/* tslint:disable */
/* eslint-disable */
/**
 * Aerscape API
 * Aerscape API documentation (internal).
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ParamChoiceSchema } from './ParamChoiceSchema';
import {
    ParamChoiceSchemaFromJSON,
    ParamChoiceSchemaFromJSONTyped,
    ParamChoiceSchemaToJSON,
    ParamChoiceSchemaToJSONTyped,
} from './ParamChoiceSchema';

/**
 * Schema-only description of one flattened param spec — see ``flatten_param_spec``.
 * 
 * The spec starts life as a plain dict on the ``workflow_action`` decorator and may carry a
 * ``scope`` callable, so there is no model or serializer behind it to infer from.
 * @export
 * @interface ParamSpecSchema
 */
export interface ParamSpecSchema {
    /**
     * 
     * @type {string}
     * @memberof ParamSpecSchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ParamSpecSchema
     */
    type: string;
    /**
     * 
     * @type {boolean}
     * @memberof ParamSpecSchema
     */
    isReference: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ParamSpecSchema
     */
    deprecated: boolean;
    /**
     * 
     * @type {Array<ParamChoiceSchema>}
     * @memberof ParamSpecSchema
     */
    choices: Array<ParamChoiceSchema>;
}

/**
 * Check if a given object implements the ParamSpecSchema interface.
 */
export function instanceOfParamSpecSchema(value: object): value is ParamSpecSchema {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if ((!('isReference' in (value as Record<string, any>)) && !('is_reference' in (value as Record<string, any>))) || ((value as Record<string, any>)['isReference'] === undefined && (value as Record<string, any>)['is_reference'] === undefined)) return false;
    if (!('deprecated' in value) || value['deprecated'] === undefined) return false;
    if (!('choices' in value) || value['choices'] === undefined) return false;
    return true;
}

export function ParamSpecSchemaFromJSON(json: any): ParamSpecSchema {
    return ParamSpecSchemaFromJSONTyped(json, false);
}

export function ParamSpecSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ParamSpecSchema {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'type': json['type'],
        'isReference': json['is_reference'],
        'deprecated': json['deprecated'],
        'choices': ((json['choices'] as Array<any>).map(ParamChoiceSchemaFromJSON)),
    };
}

export function ParamSpecSchemaToJSON(json: any): ParamSpecSchema {
    return ParamSpecSchemaToJSONTyped(json, false);
}

export function ParamSpecSchemaToJSONTyped(value?: ParamSpecSchema | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'type': value['type'],
        'is_reference': value['isReference'],
        'deprecated': value['deprecated'],
        'choices': ((value['choices'] as Array<any>).map(ParamChoiceSchemaToJSON)),
    };
}

